import React from 'react';
import { Box, Typography } from '@mui/material';
import { GridPagination } from '@mui/x-data-grid';
import CustomTablePagination from './CustomTablePagination';

const CustomDataGridPagination = (props) => {
    const {
        rowsPerPage,
        setRowsPerPage,
        setPage,
        options,
        ...gridPaginationProps
    } = props;

    return (
        <Box
            sx={{
                px: 1,
                py: 0.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                '& .MuiTablePagination-toolbar .MuiTablePagination-selectLabel': { display: 'none' },
                '& .MuiTablePagination-toolbar .MuiInputBase-root': { display: 'none' }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" gutterBottom>
                    Rows per page:
                </Typography>
                <CustomTablePagination
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    setPage={setPage}
                    options={options}
                />
            </Box>

            <GridPagination {...gridPaginationProps} />
        </Box>
    );
};

export default CustomDataGridPagination;
